/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 27th 2022, 12:46:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useAPIGetGoogleOAuthServer } from "authentication/services/OAuthAPI";
import { SaaSOnlyWrapper } from "authorization";
import CircularProgress from "@mui/material/CircularProgress";

export const GoogleSignInButton = () => {
  const { redirectToGoogleOAuthServer, isRedirectingToOAuthServer } = useAPIGetGoogleOAuthServer();

  return (
    <SaaSOnlyWrapper>
      <button className="other-login-options login-with-google" onClick={redirectToGoogleOAuthServer}>
        {isRedirectingToOAuthServer ? (
          <CircularProgress size={20} />
        ) : (
          <img className="image-style-A auth-logo" src="/img/google-icon.svg" alt="Google" />
        )}
        <div>Sign in with Google</div>
      </button>
    </SaaSOnlyWrapper>
  );
};
